import type { BackLinkOptions } from './types';

import { fetchTeamsByPlayerId } from '@apis/teams';
import { getIdFromPath } from '@cobalt/utilities';
import { isReferrerFromDomain } from '@utilities/url';

export const handleGoBack = async (isStory: boolean, customUrl?: string) => {
  if (customUrl) {
    window.location.href = customUrl;
    return;
  }

  switch (true) {
    case location.href.includes('/players/'):
      await handleGoBackToPlayerTeams(location.href);
      break;
    case location.href.includes('/match/'):
      redirectToCompetitionsPages('fixtures-results/');
      break;
    case isStory && location.href.includes('/news-media/'):
      handleGoBackToNewsMediaStories('stories/');
      break;
    case location.href.includes('/topic/'):
      handleGoBackToNewsMediaStories('');
      break;
    case location.href.includes('/video/highlights/'):
      redirectToCompetitionsPages('video/highlights/');
      break;
    case location.href.includes('/video/'):
      redirectToVideoPages();
      break;
    default:
      handleGoBackToModifiedCurrentPage(location.href);
  }
};

const handleGoBackToPlayerTeams = async (currentPage: string) => {
  //check competitionid, otherwise redirect to root, the return is for the tests
  if (!window.competitionId) {
    redirectToHome();
    return;
  }
  const playerId = getIdFromPath(currentPage);
  const result = await fetchTeamsByPlayerId({
    competitionId: window.competitionId,
    seasonYear: 'current',
    playerId: [playerId],
  });

  const firstTeamId = result?.[0]?.teamId;
  if (firstTeamId) {
    const clubOrTeam = window.isClub ? 'clubs/' : 'teams/';
    redirectToCompetitionsPages(`${clubOrTeam}${firstTeamId}/`);
  }
};
/**
 * Redirect to video pages, if on the root of videos redirect to competition root
 */
const redirectToVideoPages = () => {
  if (location.href.endsWith('/video/') || location.href.endsWith('/video')) {
    redirectToCompetitionsPages('');
    return;
  }

  const lastUrlSegment = location.href.replace(regexFindLastUrlSegment, '');
  const endpoint = lastUrlSegment.endsWith('/video') ? '' : 'video/';

  // Redirect to the competitions pages adding the endpoint
  redirectToCompetitionsPages(endpoint);
};

const redirectToCompetitionsPages = (endpoint: string) => {
  const { protocol, host } = window.location;
  const newURL = `${protocol}//${host}/${window.competitionName}/${endpoint}`;
  window.location.href = newURL;
};

/* Handle case of Articles that has a hashtag Story & Topic page */
const handleGoBackToNewsMediaStories = (endpoint: string) => {
  const { protocol, host } = window.location;
  const newURL = `${protocol}//${host}/news-media/${endpoint}`;
  window.location.href = newURL;
};

/* Handle general case removing the last /{id}/ case */
const handleGoBackToModifiedCurrentPage = (currentPage: string) => {
  const modifiedCurrentPage = currentPage.replace(regexFindLastUrlSegment, '');
  window.location.href = modifiedCurrentPage;
};

const redirectToHome = () => {
  const { protocol, host } = window.location;
  const newURL = `${protocol}//${host}`;
  window.location.href = newURL;
};

export const shouldHideBackLink = (options?: BackLinkOptions) => {
  const domain = location.hostname === 'localhost' ? 'localhost' : '.uefa.com';
  return (
    (!options?.skipReferrerCheck && isReferrerFromDomain(domain)) ||
    (!options?.showOnMobile && new URLSearchParams(location.search).has('mobileView'))
  );
};

const regexFindLastUrlSegment = /\/[^/]+\/?$/;
